import { GhccMessageType } from './ghccMessageTypes';
export const sendMetricsToDatadog = (message, activityMetricsInstance) => {
    var _a, _b;
    switch (message.type) {
        case GhccMessageType.initializeActivity:
            activityMetricsInstance === null || activityMetricsInstance === void 0 ? void 0 : activityMetricsInstance.onInitializeActivity((_a = message.payload) === null || _a === void 0 ? void 0 : _a.ActivityClientID);
            break;
        case GhccMessageType.terminateActivity:
            activityMetricsInstance === null || activityMetricsInstance === void 0 ? void 0 : activityMetricsInstance.onTerminateActivity((_b = message.payload) === null || _b === void 0 ? void 0 : _b.ActivityClientID);
            break;
        default:
            break;
    }
};
//# sourceMappingURL=metricUtils.js.map